import _ from 'lodash';
import { DefaultPage } from '../features/acesso-negado/';
import acessoNegadoRoute from '../features/acesso-negado/route';
import { Logout } from '../features/acesso-sistema';
import acessoSistemaRoute from '../features/acesso-sistema/route';
import commonRoute from '../features/common/route';
import componentesRoute from '../features/componentes/route';
import examplesRoute from '../features/examples/route';
import homeRoute from '../features/home/route';
import loginSapRoute from '../features/login-sap/route';
import logsSistemaRoute from '../features/logs-sistema/route';
import { MasterPage, PaginaNaoEncontrada } from '../features/master-page';
import masterPageRoute from '../features/master-page/route';
import pagesRoute from '../features/pages/route';
import parametrosSistemaRoute from '../features/parametros-sistema/route';
import pessoasRoute from '../features/pessoas/route';
import storageRoute from '../features/storage/route';
import usuarioPerfilRoute from '../features/usuario-perfil/route';
import arquivosRoute from '../features/arquivos/route';
import usuariosRoute from '../features/usuarios/route';


// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [
  homeRoute,
  examplesRoute,
  masterPageRoute,
  componentesRoute,
  acessoSistemaRoute,
  pessoasRoute,
  storageRoute,
  parametrosSistemaRoute,
  pagesRoute,
  usuariosRoute,
  usuarioPerfilRoute,
  arquivosRoute,
  commonRoute,
  loginSapRoute,
  logsSistemaRoute,
  acessoNegadoRoute,
];

const routes = [
  {
    path: '/signout',
    component: Logout,
  },
  {
    path:'/acesso-negado',
    component:DefaultPage
  },
  {
    path: '/',
    component: MasterPage,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PaginaNaoEncontrada },
    ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  }
];

// Handle isIndex property of route config:
//  Dupicate it and put it as the first route rule.
function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, child => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true; // mark it so that the simple nav won't show it.
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;



// WEBPACK FOOTER //
// ./src/common/routeConfig.js